import { render, staticRenderFns } from "./headerLinkPop.vue?vue&type=template&id=16cb9c55&scoped=true"
import script from "./headerLinkPop.vue?vue&type=script&lang=ts"
export * from "./headerLinkPop.vue?vue&type=script&lang=ts"
import style0 from "./headerLinkPop.vue?vue&type=style&index=0&id=16cb9c55&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb9c55",
  null
  
)

export default component.exports